var constants = require('./constants');

module.exports = function (selector, keyFunctions, preFunction) {
    $(document).on('keydown', selector, function (e) {
        var key = e.which;
        var supportedKeyCodes = [
            constants.KEY_CODE_LEFT,
            constants.KEY_CODE_UP,
            constants.KEY_CODE_RIGHT,
            constants.KEY_CODE_DOWN,
            constants.KEY_CODE_ESC,
            constants.KEY_LEFT,
            constants.KEY_UP,
            constants.KEY_RIGHT,
            constants.KEY_DOWN,
            constants.KEY_ESC
        ];
        if (supportedKeyCodes.indexOf(key) >= 0) {
            e.preventDefault();
        }
        var returnedScope = preFunction.call(this);
        if (keyFunctions[key]) {
            keyFunctions[key].call(this, returnedScope, e);
        }
    });
};
